import { PublicClientApplication, InteractionRequiredAuthError } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_SSO_CLIENT_ID,
    authority: process.env.REACT_APP_SSO_AUTHORITIES,
    knownAuthorities: [process.env.REACT_APP_SSO_KNOWN_AUTHORITIES],
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
};

const loginRequest = {
  scopes:[`api://e438e517-dbd1-4e8e-a01b-df08540c0276/access_as_user`]
};

const loginRequest1 = {
  scopes:['User.Read']
};

const msalInstance = new PublicClientApplication(msalConfig);

// 🟡 Ensure initialized BEFORE any call
await msalInstance.initialize();

export const getToken = async () => {
  let accounts = msalInstance.getAllAccounts();

  if (accounts.length === 0) {
    console.warn('No accounts found. Attempting interactive login...');
    try {
      await msalInstance.loginPopup(loginRequest);
      accounts = msalInstance.getAllAccounts();
      if (accounts.length === 0) {
        throw new Error('Login failed. No account returned.');
      }
    } catch (loginError) {
      console.error('Login popup failed.', loginError);
      alert('Login failed. Please refresh the page and try again.');
      throw loginError;
    }
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      account: accounts[0],
      scopes: loginRequest.scopes,
    });
    return response.accessToken;
  } catch (error) {
    console.warn('Silent token acquisition failed.', error);

    if (error instanceof InteractionRequiredAuthError) {
      try {
        const response = await msalInstance.acquireTokenPopup({
          scopes: loginRequest.scopes,
        });
        return response.accessToken;
      } catch (popupError) {
        console.error('Interactive token acquisition failed.', popupError);
        alert('Authentication failed. Please try again.');
        throw popupError;
      }
    } else {
      console.error('Token acquisition failed due to an unexpected error.', error);
      throw error;
    }
  }
};

export { loginRequest, msalInstance,loginRequest1 };